/**
 * React Query hooks for trips data
 */

import { useQuery } from '@tanstack/react-query';
import { getTrips, getPendingFlights } from '@/services/tripService';
import type { Trip, Flight } from '@/services/tripService';

/**
 * Hook to get all trips for the current user
 */
export function useTrips(status?: string) {
  return useQuery<Trip[], Error>({
    queryKey: ['trips', status],
    queryFn: () => getTrips(status),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to get active trips (IN_PROGRESS status)
 */
export function useActiveTrips() {
  return useTrips('IN_PROGRESS');
}

/**
 * Hook to get pending flights that need data entry
 * Returns Trip-based Flight[] from all user's trips
 */
export function usePendingFlights() {
  return useQuery<Flight[], Error>({
    queryKey: ['trips', 'pending-flights'],
    queryFn: () => getPendingFlights(),
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
}